<div id="wallboard-config">

  <label class="uk-form-label rotationlabel">Select a site to configure</label>
  <select class="uk-select" (change)="handleSiteChange($event.target.value);">
    <option value="" [selected]='newState'>Select Site</option>
    <option *ngFor="let site of wallboardService.siteList">
      {{ site }}
    </option>
  </select>

  <div class="addButton" *ngIf="!wallboardService.activeSiteName">
    <p> OR </p>
    <button mat-raised-button color="primary" [routerLink]="['/' + configService.activeLOB + '/wallboard/add']">Create New Configuration</button>
  </div>

  <div class="queue-select" *ngIf="wallboardService.activeSiteName && !wallboardService.activeQueueConfig.AggregateView">
    <label class="uk-form-label rotationlabel">Select a queue</label>
    <select class="uk-select" [(ngModel)]="wallboardService.activeQueueName" (change)="wallboardService.setActiveQueue($event.target.value, wallboardService.activeSiteName); validateInput()">
      <option value="">Select Queue</option>
      <option *ngFor="let queue of wallboardService.queueList">
        {{ queue }}
      </option>
    </select>
  </div>



  <div class="config-container" *ngIf="wallboardService.activeQueueName && !wallboardService.activeQueueConfig.AggregateView">
    <app-wb-config
      [activeConfig]="wallboardService.activeQueueConfig"
      [aggregate]="false"
      (validationChange)="validateInput()"
      *ngIf="!wallboardService.activeQueueConfig.AggregateView">
    </app-wb-config>
  </div>

  <div class="config-container" *ngIf="wallboardService.activeQueueName && wallboardService.activeQueueConfig.AggregateView">
    <form #wallboardConfig="ngForm">
      <fieldset>
        <div class="uk-margin" *ngIf="(wallboardService.activeQueueConfig.hasOwnProperty('AggregateView'))">
          <label class="uk-form-label rotationlabel">Refresh Interval</label>
          <input class="refresh-interval-slider" type="range" min="5" max="45" list="steplist" [(ngModel)]="wallboardService.activeQueueConfig.RefreshInterval" name="rotationDelay">
          <datalist id="steplist">
            <option>5</option>
            <option>10</option>
            <option>15</option>
            <option>20</option>
            <option>25</option>
            <option>30</option>
            <option>35</option>
            <option>40</option>
            <option>45</option>
          </datalist>
          <app-time-display secondsOnly="true" [timeInSeconds]="wallboardService.activeQueueConfig.RefreshInterval"></app-time-display>
        </div>
      
        <div class="uk-margin" *ngIf="wallboardService.activeQueueConfig.AggregateView">
          <label class="uk-form-label rotationlabel">Announcements</label>
          <input type="text" [(ngModel)]="wallboardService.activeQueueConfig.Announcements" name="Announcements">
        </div>
      </fieldset>
    </form>
    <app-wb-config
      [activeConfig]="wallboardService.activeQueueConfig.LeftPane"
      [aggregate]="true"
      (validationChange)="validateInput()"
      *ngIf="wallboardService.activeQueueConfig.AggregateView">
    </app-wb-config>
    <app-wb-config
      [activeConfig]="wallboardService.activeQueueConfig.RightPane"
      [aggregate]="true"
      (validationChange)="validateInput()"
      *ngIf="wallboardService.activeQueueConfig.AggregateView">
    </app-wb-config>
  </div>

  <div fxLayoutGap="10px">
    <button
      mat-raised-button
      color="primary"
      *ngIf="(wallboardService.activeSiteName && wallboardService.activeQueueConfig.AggregateView) || (wallboardService.activeSiteName && wallboardService.activeQueueName)"
      (click)="updateConfig()"
      [disabled]="!formValid"
    >
      SUBMIT
    </button>
    <button
      mat-raised-button
      color="accent"
      *ngIf="(wallboardService.activeSiteName && wallboardService.activeQueueConfig.AggregateView) || (wallboardService.activeSiteName && wallboardService.activeQueueName)"
      (click)="cancelSite(configService.activeLOB)"
    >
      CANCEL
    </button>
  </div>  
</div>
<br>